import { useRequest, API_PATH } from '../hooks/useRequest';
/**
 * ============================================
 * C端 - 活动信息查询接口
 * ============================================
 */
/**
 * Hook - 查询活动信息
 * @returns 包含请求函数和状态的对象
 */
export const useQueryActivityInfo = () => {
    return useRequest(API_PATH.ACTIVITY_INFO);
};
/**
 * ============================================
 * C端 - 抽奖接口
 * ============================================
 */
/**
 * Hook - 执行抽奖
 * @returns 包含请求函数和状态的对象
 */
export const usePerformDraw = () => {
    return useRequest(API_PATH.DRAW_PRIZE);
};
/**
 * ============================================
 * C端 - 邀请任务完成接口
 * ============================================
 */
/**
 * Hook - 完成任务（邀请任务）
 * @returns 包含请求函数和状态的对象
 */
export const useCompleteTask = () => {
    return useRequest(API_PATH.COMPLETE_TASK);
};
/**
 * ============================================
 * C端 - 优惠券使用记录查询接口
 * ============================================
 */
/**
 * Hook - 查询优惠券使用列表
 * @returns 包含请求函数和状态的对象
 */
export const useGetCouponUsageList = () => {
    return useRequest(API_PATH.COUPON_USAGE_LIST);
};
